module.exports = __webpack_public_path__ + "img/logo.bb843007.png";